export const getRandomInt = (min: number, max: number) => {
  min = Math.round(min)
  max = Math.round(max)
  return Math.round(Math.random() * (max - min) + min)
}
